<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-card-code class="mt-1">
          <b-card-title class="mb-1 text-left">
            Marcaciones realizadas en el mes (Persona)
          </b-card-title>
          <div id="chart">
            <vue-apex-charts
              type="bar"
              height="452"
              :options="chartOptions"
              :series="series"
              ref="barStackedChart"
            ></vue-apex-charts>
          </div>
        </b-card-code>
      </b-col>

      <b-col md="6">
        <b-card-code class="mt-1">
          <b-overlay
            :show="mostrarLoaderBoletos"
            spinner-variant="primary"
            spinner-type="grow"
          >
            <div class="d-flex justify-content-between align-items-center mb-1">
              <b-card-title class="mb-0">Boletos comprados en el mes</b-card-title>
              <b-button-group size="sm">
                <b-button
                  :variant="graficoBoletos === 'cantidad' ? 'primary' : 'outline-primary'"
                  @click="cambiarTipoGrafico('cantidad')"
                >
                  <feather-icon icon="BarChart2Icon" size="16" class="mr-50" />
                  Cantidad
                </b-button>
                <b-button
                  :variant="graficoBoletos === 'ventas' ? 'primary' : 'outline-primary'"
                  @click="cambiarTipoGrafico('ventas')"
                >
                  <feather-icon icon="DollarSignIcon" size="16" class="mr-50" />
                  Ventas
                </b-button>
              </b-button-group>
            </div>

            <b-card-body>
              <vue-apex-charts
                ref="comparisonBoletos"
                :type="chartType"
                height="400"
                :options="chartOptionsBoletos"
                :series="seriesBoletosProcesada"
              />
            </b-card-body>
          </b-overlay>
        </b-card-code>
      </b-col>
    </b-row>

    <b-card-group>
      <!-- <b-card class="mt-2 mr-1">
        <b-overlay
          :show="mostrarLoaderCombinado"
          spinner-variant="primary"
          spinner-type="grow"
        >
          <b-card-title class="mb-1 text-center">
            Marcaciones realizadas en el mes (Persona, Combinado)
          </b-card-title>
          <vue-apex-charts
            ref="comparisonLineChart5"
            type="donut"
            height="420"
            :options="donutChart5.chartOptions"
            :series="donutChart5.series"
          />
        </b-overlay>
      </b-card> -->
      <b-card class="mt-2">
        <b-overlay
          :show="mostrarLoaderBoleto"
          spinner-variant="primary"
          spinner-type="grow"
        >
          <b-card-title class="mb-1 text-center">
            Marcaciones realizadas en el mes (Boleto)
          </b-card-title>
          <vue-apex-charts
            ref="comparisonLineChart3"
            type="donut"
            height="420"
            :options="donutChart2.chartOptions"
            :series="donutChart2.series"
          />
        </b-overlay>
      </b-card>
    </b-card-group>
    <!-- <b-card-group>
      <b-card class="mt-2 mr-1">
        <b-overlay
          :show="mostrarLoaderPersonaPasajero"
          spinner-variant="primary"
          spinner-type="grow"
        >
          <b-card-title class="mb-1 text-center">
            Marcaciones realizadas en el mes (Persona, Tipo Pasajero)
          </b-card-title>

          <vue-apex-charts
            ref="comparisonLineChart4"
            type="donut"
            height="420"
            :options="donutChart4.chartOptions"
            :series="donutChart4.series"
          />
        </b-overlay>
      </b-card>
      <b-card class="mt-2">
        <b-overlay
          :show="mostrarLoaderPersona"
          spinner-variant="primary"
          spinner-type="grow"
        >
          <b-card-title class="mb-1 text-center">
            Marcaciones realizadas en el mes (Persona, Tipo Residente)
          </b-card-title>

          <vue-apex-charts
            ref="comparisonLineChart"
            type="donut"
            height="420"
            :options="donutChart.chartOptions"
            :series="donutChart.series"
          />
        </b-overlay>
      </b-card>
    </b-card-group> -->
    <b-card class="mt-2">
      <b-overlay
        :show="mostrarLoaderAnual"
        spinner-variant="primary"
        spinner-type="grow"
      >
        <b-card-title class="mb-1 text-center">
          Marcaciones anuales
        </b-card-title>
        <b-card-body>
          <vue-apex-charts
            ref="comparisonLineChart2"
            type="line"
            height="400"
            :options="lineChartSimple.chartOptions"
            :series="lineChartSimple.series"
          />
        </b-card-body>
      </b-overlay>
    </b-card>
    <b-card class="mt-2">
      <b-card-title class="mb-1 text-center"> Viajes en curso </b-card-title>
      <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
        <b-row>
          <b-col v-if="items.length > 0" cols="12" class="pr-0 pl-0 mt-2">
            <b-table
              bordered
              striped
              responsive
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #cell(codigo)="data">
                <b-link
                  :to="{
                    name: 'marcacion',
                    params: { token: data.item.token },
                  }"
                >
                  {{ data.value }}
                </b-link>
              </template>

              <template #cell(chofer)="data">
                <span>{{
                  data.item.chofer.first_name + " " + data.item.chofer.last_name
                }}</span>
              </template>
              <template v-slot:cell(trayecto)="data">
                <span
                  v-b-tooltip.hover
                  :title="
                    data.item.trayecto.origen.nombre +
                    ' - ' +
                    data.item.trayecto.destino.nombre
                  "
                  >{{
                    data.item.trayecto.origen.codigo +
                    " - " +
                    data.item.trayecto.destino.codigo
                  }}</span
                >
              </template>
              <template #cell(fecha_inicio)="data">
                {{ new Date(data.value).toLocaleString("pt-BR") }}
              </template>
              <template v-slot:cell(num_pasajeros_marcado)="data">
                <span>{{
                  data.value + "/" + data.item.bus.cantidad_pasajeros
                }}</span>
              </template>
            </b-table>
          </b-col>
          <div v-else>
            <span>En este momento no hay viajes en curso.</span>
          </div>
        </b-row>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BCardHeader,
  BCardGroup,
  VBTooltip,
  BLink,
  BOverlay,
  BButtonGroup,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
// import apexChatData from '@/views/charts-and-maps/charts/apex-chart/apexChartData'
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import $ from "jquery";
import actions from "@/assets/utils/utils";
import { $themeColors } from "@themeConfig";

export default {
  components: {
    VueApexCharts,
    BCardGroup,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardHeader,
    BCardBody,
    BLink,
    BOverlay,
    BButtonGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      mostrarLoaderPersona: true,
      mostrarLoaderBoleto: true,
      mostrarLoaderAnual: true,
      mostrarLoaderPersonaPasajero: true,
      mostrarLoaderCombinado: true,
      mostrarLoaderBoletos: true,

      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: function (val) {
              return val;
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },

        colors: [
          "#6CADDF",
          "#E194BC",
          "#FAB26A",
          "#AE77B2",
          "#F27077",
          "#9DD374",
          "#DA8868",
          "#DC69AA",
          "#6978AA",
          "#939393",
        ],
      },

      donutChart5: {
        series: [30, 40, 50, 60, 70, 80, 20, 10],
        chartOptions: {
          legend: {
            show: true,
            position: "right",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: [
            "#ffe700",
            "#00d4bd",
            "#826bf8",
            "#2b9bf4",
            "#FFA1A1",
            "#D6234A",
            "#2D7AC0",
            "#C3A492",
            "#A43E00",
            "#FF5733",
            "#33FF57",
            "#3B3B98",
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "Total boletos",
                    formatter(w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    },
                  },
                },
              },
            },
          },
          labels: [
            "testing1",
            "testing2",
            "testing3",
            "testing4",
            "testing5",
            "testing6",
            "testing7",
            "testing8",
          ],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
      donutChart4: {
        series: [30, 40, 50, 60, 70, 80, 20, 10],
        chartOptions: {
          legend: {
            show: true,
            position: "right",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: [
            "#ffe700",
            "#00d4bd",
            "#826bf8",
            "#2b9bf4",
            "#FFA1A1",
            "#D6234A",
            "#2D7AC0",
            "#C3A492",
            "#A43E00",
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "Total boletos",
                    formatter(w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    },
                  },
                },
              },
            },
          },
          labels: [
            "testing1",
            "testing2",
            "testing3",
            "testing4",
            "testing5",
            "testing6",
            "testing7",
            "testing8",
          ],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
      donutChart2: {
        series: [30, 40, 50, 60, 70, 80, 20, 10],
        chartOptions: {
          legend: {
            show: true,
            position: "right",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: [
            "#ffe700",
            "#00d4bd",
            "#826bf8",
            "#2b9bf4",
            "#FFA1A1",
            "#D6234A",
            "#2D7AC0",
            "#C3A492",
            "#A43E00",
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "Total boletos",
                    formatter(w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    },
                  },
                },
              },
            },
          },
          labels: [
            "testing1",
            "testing2",
            "testing3",
            "testing4",
            "testing5",
            "testing6",
            "testing7",
            "testing8",
          ],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },

      // donutChart2: {
      //   series: [44, 55, 13, 33],
      //   chartOptions: {
      //     chart: {
      //       // width: 380,
      //       type: 'donut',
      //     },
      //     dataLabels: {
      //       enabled: false
      //     },
      //     responsive: [{
      //       breakpoint: 480,
      //       options: {
      //         chart: {
      //           width: 200
      //         },
      //         legend: {
      //           show: false
      //         }
      //       }
      //     }],
      //     legend: {
      //       position: 'right',
      //       offsetY: 0,
      //       height: 230,
      //     }
      //   },
      // },
      donutChart: {
        series: [30, 40, 50, 60, 70],
        chartOptions: {
          legend: {
            show: true,
            position: "right",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          colors: ["#ffe700", "#00d4bd", "#826bf8", "#2b9bf4", "#FFA1A1"],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "2rem",
                    fontFamily: "Montserrat",
                  },
                  value: {
                    fontSize: "1rem",
                    fontFamily: "Montserrat",
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    fontSize: "1.5rem",
                    label: "Total pasajeros",
                    formatter(w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    },
                  },
                },
              },
            },
          },
          labels: ["testing1", "testing2", "testing3", "testin4", "testing5"],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },

      lineChartSimple: {
        series: [
          {
            name: new Date().getFullYear(),
            data: [280, 200, 220, 180, 270, 250, 70, 90, 200, 150, 160, 100],
          },
          {
            name: new Date().getFullYear() - 1,
            data: [120, 200, 300, 250, 280, 250, 200, 100, 150, 130, 90, 152],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.success, $themeColors.warning],
          },
          colors: [$themeColors.success, $themeColors.warning],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${
                data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`;
            },
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },

      chartType: 'bar',
      graficoBoletos: 'cantidad',

      lineChartSimple2: {
        series: [
          {
            name: 'Físico',
            data: [280, 200, 220, 180, 270, 250, 70, 90, 200, 150, 160, 100],
          },
          {
            name: 'Digital',
            data: [120, 200, 300, 250, 280, 250, 200, 100, 150, 130, 90, 152],
          },
          {
            name: 'Tarjeta',
            data: [120, 200, 300, 250, 280, 100, 200, 100, 150, 130, 90, 132],
          },
        ],
        chartOptions: {
          chart: {
            type: 'bar', // 🔁 CAMBIADO a 'bar'
            stacked: false,
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '80%', // ajusta el ancho de las columnas
              endingShape: 'rounded',
            },
          },
          colors: [$themeColors.success, $themeColors.warning, $themeColors.danger],
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
          },
          xaxis: {
            categories: [], // se actualizará dinámicamente
          },
          yaxis: {
            // opposite: isRtl,
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val, opts) {
                const series = opts.w.config.series
                const dataPointIndex = opts.dataPointIndex
                const totalMes = series.reduce((sum, s) => sum + (s.data[dataPointIndex] || 0), 0)
                const porcentaje = totalMes > 0 ? ((val / totalMes) * 100).toFixed(1) : 0
                return `${val} boletos (${porcentaje}%)`
              }
            },
          },
          legend: {
            position: 'top',
          },
        },
      },

      // apexChatData,
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "codigo",
          label: "Código",
          thClass: "text-center",
        },
        {
          key: "trayecto",
          label: "Trayecto",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "bus.placa",
          label: "Bus",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fecha_inicio",
          label: "Fecha inicio",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "chofer",
          label: "Chófer",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "num_pasajeros_marcado",
          label: "# Marcados",
          sortable: true,
          tdClass: (value, key, item) => {
            if (value > item.bus.cantidad_pasajeros) {
              return "text-red";
            }
          },
          thClass: "text-center",
        },
      ],
      items: [],
      mostrarLoader: false,

      // fechaInicio: new Date(),
      // fechaInicioAPI: new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth(), 1).toLocaleString('pt-BR').split(' ')[0],
      //
      // fechaFin: new Date(),
      // fechaFinAPI: new Date(this.fechaFin.getFullYear(), this.fechaFin.getMonth() + 1, 0).toLocaleString('pt-BR').split(' ')[0],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    seriesBoletosProcesada() {
      if (this.graficoBoletos === 'ventas') {
        return this.lineChartSimple2.series.map(serie => ({
          name: serie.name,
          data: serie.data.map(valor => valor * 5),
        }))
      } else {
        return this.lineChartSimple2.series
      }
    },
    chartOptionsBoletos() {
      const esVentas = this.graficoBoletos === 'ventas'
      const series = this.seriesBoletosProcesada

      const formatter = (val, opts) => {
        const idx = opts.dataPointIndex
        const totalMes = series.reduce((sum, s) => sum + (s.data[idx] || 0), 0)
        const porcentaje = totalMes > 0 ? ((val / totalMes) * 100).toFixed(1) : 0

        // Retorna el formato correcto según el modo actual
        return esVentas
          ? `$${parseFloat(val).toFixed(2)} (${porcentaje}%)`
          : `${val} boletos (${porcentaje}%)`
      }

      return {
        ...this.lineChartSimple2.chartOptions,
        tooltip: {
          y: {
            formatter,
          }
        }
      }
    },
  },
  created() {
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
    // this.cargarCantidadxTipoPasajero()
  },
  mounted() {
    this.cargarCantidadxTipoPasajero();
    this.cargarCantidadxTipoPersonaPasajero();
    this.cargarCantidadMarcacionXAnio();
    this.cargarCantidadxTipoCombinado();
    this.cargarReporte();
    this.cargarCantidadBoletosXAnio();
    // Set the initial number of items
    this.cargarDatosViajes();
    this.cargarCantidadxTipoBoleto();
    this.totalRows = this.items.length;

    // $('#contenedor-botones').append($('#btn-excel')).append($('#btn-pdf'))
  },
  methods: {
    cambiarTipoGrafico(tipo) {
      this.graficoBoletos = tipo
      this.chartType = 'bar' // O 'line' si deseas que se vea diferente en ventas
    },
    cargarCantidadxTipoBoleto() {
      this.mostrarLoaderBoleto = true;
      const fechaInicio = new Date();
      const fechaInicioAPI = new Date(
        fechaInicio.getFullYear(),
        fechaInicio.getMonth(),
        1
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      const fechaFin = new Date();
      const fechaFinAPI = new Date(
        fechaFin.getFullYear(),
        fechaFin.getMonth() + 1,
        0
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      axios
        .post("api", {
          query: `query getCantidadXTipoBoleto($fechaDesde: String!, $fechaHasta: String!){
            getCantidadXTipoBoleto(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta){
                listaCantidades,
                listaLabels,
                total,
                status,
                message
            }
        }`,
          variables: {
            fechaDesde: fechaInicioAPI,
            fechaHasta: fechaFinAPI,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadXTipoBoleto.status === "success"
            ) {
              this.$refs.comparisonLineChart3.updateOptions({
                series:
                  response.data.data.getCantidadXTipoBoleto.listaCantidades,
                labels: response.data.data.getCantidadXTipoBoleto.listaLabels,
                total: response.data.data.getCantidadXTipoBoleto.total,
              });
              setTimeout(() => {
                this.mostrarLoaderBoleto = false;
              }, 300);
              // this.mostrarLoaderBoleto = false
            }
          }
        });
    },
    cargarReporte() {
      const fechaInicio = new Date();
      const fechaInicioAPI = new Date(
        fechaInicio.getFullYear(),
        fechaInicio.getMonth(),
        1
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      const fechaFin = new Date();
      const fechaFinAPI = new Date(
        fechaFin.getFullYear(),
        fechaFin.getMonth() + 1,
        0
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      axios
        .post("api", {
          query: `query getReporteOperativoPersona($fechaDesde: String!, $fechaHasta: String!) {
                    getReporteOperativoPersona(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta) {
                        nombresResidentes,
                        tarifasCantidades {
                            guia {
                                nombre,
                                cantidades,
                            },
                            concesionario {
                                nombre,
                                cantidades,
                            },
                            general {
                                nombre,
                                cantidades,
                            },
                        },
                        status,
                        message,
                    }
                }`,
          variables: {
            fechaDesde: fechaInicioAPI,
            fechaHasta: fechaFinAPI,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getReporteOperativoPersona.status === "success"
            ) {
              let reporte =
                response.data.data.getReporteOperativoPersona.tarifasCantidades;

              if (
                response.data.data.getReporteOperativoPersona.nombresResidentes
                  .length !== 0
              ) {
                let customSeries = [];

                // Preparar los datos para el gráfico
                for (var key in reporte) {
                  let tarifa = {
                    name: reporte[key]["nombre"],
                    data: reporte[key]["cantidades"],
                  };
                  customSeries.push(tarifa);
                }

                // Actualizar el gráfico
                this.$refs.barStackedChart.updateOptions({
                  series: customSeries,
                  xaxis: {
                    categories:
                      response.data.data.getReporteOperativoPersona
                        .nombresResidentes,
                  },
                });
              } else {
                // Vaciar gráfico si no hay datos
                let customSeries = [];
                this.$refs.barStackedChart.updateOptions({
                  series: customSeries,
                  xaxis: {
                    categories: [],
                  },
                });
              }
            } else {
              console.error(
                response.data.data.getReporteOperativoPersona.message
              );
            }
          }
          this.mostrarLoader = false;
        })
        .catch((error) => {
          console.error("Error cargando el reporte: ", error);
          this.mostrarLoader = false;
        });
    },

    cargarCantidadxTipoPasajero() {
      this.mostrarLoaderPersona = true;
      const fechaInicio = new Date();
      const fechaInicioAPI = new Date(
        fechaInicio.getFullYear(),
        fechaInicio.getMonth(),
        1
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      const fechaFin = new Date();
      const fechaFinAPI = new Date(
        fechaFin.getFullYear(),
        fechaFin.getMonth() + 1,
        0
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      axios
        .post("api", {
          query: `query getCantidadXTipoPasajero($fechaDesde: String!, $fechaHasta: String!){
            getCantidadXTipoPasajero(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta){
                listaCantidades,
                listaLabels,
                total,
                status,
                message
            }
        }`,
          variables: {
            fechaDesde: fechaInicioAPI,
            fechaHasta: fechaFinAPI,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadXTipoPasajero.status === "success"
            ) {
              this.$refs.comparisonLineChart.updateOptions({
                series:
                  response.data.data.getCantidadXTipoPasajero.listaCantidades,
                labels: response.data.data.getCantidadXTipoPasajero.listaLabels,
                total: response.data.data.getCantidadXTipoPasajero.total,
              });
              setTimeout(() => {
                this.mostrarLoaderPersona = false;
              }, 1000);
            }
          }
        });
    },
    cargarCantidadxTipoPersonaPasajero() {
      this.mostrarLoaderPersonaPasajero = true;
      const fechaInicio = new Date();
      const fechaInicioAPI = new Date(
        fechaInicio.getFullYear(),
        fechaInicio.getMonth(),
        1
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      const fechaFin = new Date();
      const fechaFinAPI = new Date(
        fechaFin.getFullYear(),
        fechaFin.getMonth() + 1,
        0
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      axios
        .post("api", {
          query: `query getCantidadXTipoPersonaPasajero($fechaDesde: String!, $fechaHasta: String!){
            getCantidadXTipoPersonaPasajero(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta){
                listaCantidades,
                listaLabels,
                total,
                status,
                message
            }
        }`,
          variables: {
            fechaDesde: fechaInicioAPI,
            fechaHasta: fechaFinAPI,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadXTipoPersonaPasajero.status ===
              "success"
            ) {
              this.$refs.comparisonLineChart4.updateOptions({
                series:
                  response.data.data.getCantidadXTipoPersonaPasajero
                    .listaCantidades,
                labels:
                  response.data.data.getCantidadXTipoPersonaPasajero
                    .listaLabels,
                total: response.data.data.getCantidadXTipoPersonaPasajero.total,
              });
              setTimeout(() => {
                this.mostrarLoaderPersonaPasajero = false;
              }, 1000);
            }
          }
        });
    },
    cargarCantidadxTipoCombinado() {
      this.mostrarLoaderCombinado = true;
      const fechaInicio = new Date();
      const fechaInicioAPI = new Date(
        fechaInicio.getFullYear(),
        fechaInicio.getMonth(),
        1
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      const fechaFin = new Date();
      const fechaFinAPI = new Date(
        fechaFin.getFullYear(),
        fechaFin.getMonth() + 1,
        0
      )
        .toLocaleString("pt-BR")
        .split(", ")[0];
      axios
        .post("api", {
          query: `query getCantidadXTipoCombinado($fechaDesde: String!, $fechaHasta: String!){
            getCantidadXTipoCombinado(fechaDesde: $fechaDesde, fechaHasta: $fechaHasta){
                listaCantidades,
                listaLabels,
                total,
                status,
                message
            }
        }`,
          variables: {
            fechaDesde: fechaInicioAPI,
            fechaHasta: fechaFinAPI,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadXTipoCombinado.status === "success"
            ) {
              this.$refs.comparisonLineChart5.updateOptions({
                series:
                  response.data.data.getCantidadXTipoCombinado.listaCantidades,
                labels:
                  response.data.data.getCantidadXTipoCombinado.listaLabels,
                total: response.data.data.getCantidadXTipoCombinado.total,
              });
              setTimeout(() => {
                this.mostrarLoaderCombinado = false;
              }, 1000);
            }
          }
        });
    },
    cargarCantidadMarcacionXAnio() {
      this.mostrarLoaderAnual = true;
      axios
        .post("api", {
          query: `{
            getCantidadMarcacionesXAnio{
                listaMeses,
                listaAnioActual,
                listaAnioAnterior,
                status,
                message
            }
        }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadMarcacionesXAnio.status ===
              "success"
            ) {
              this.$refs.comparisonLineChart2.updateOptions({
                series: [
                  {
                    name: new Date().getFullYear(),
                    data: response.data.data.getCantidadMarcacionesXAnio
                      .listaAnioActual,
                  },
                  {
                    name: new Date().getFullYear() - 1,
                    data: response.data.data.getCantidadMarcacionesXAnio
                      .listaAnioAnterior,
                  },
                ],
                xaxis: {
                  categories:
                    response.data.data.getCantidadMarcacionesXAnio.listaMeses,
                },
              });
              this.mostrarLoaderAnual = false;
            }
          }
        });
    },
    cargarCantidadBoletosXAnio() {
      this.mostrarLoaderBoletos = true;
      axios
        .post("api", {
          query: `{
            getCantidadBoletosXAnio{
                listaMeses,
                listaFisico,
                listaDigital,
                listaTarjeta,
                status,
                message
            }
        }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (
              response.data.data.getCantidadBoletosXAnio.status === "success"
            ) {
              this.$refs.comparisonBoletos.updateOptions({
                series: [
                  {
                    name: "Físico",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaFisico,
                  },
                  {
                    name: "Digital",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaDigital,
                  },
                  {
                    name: "Tarjeta",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaTarjeta,
                  },
                ],
                xaxis: {
                  categories:
                    response.data.data.getCantidadBoletosXAnio.listaMeses,
                },
              });
              this.lineChartSimple2.series = [
                  {
                    name: "Físico",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaFisico,
                  },
                  {
                    name: "Digital",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaDigital,
                  },
                  {
                    name: "Tarjeta",
                    data: response.data.data.getCantidadBoletosXAnio
                      .listaTarjeta,
                  },
              ],
              this.lineChartSimple2.chartOptions.xaxis = {
                  categories:
                    response.data.data.getCantidadBoletosXAnio.listaMeses,
                },
              this.mostrarLoaderBoletos = false;
            }
          }
        });
    },
    cargarDatosViajes() {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getViajes($estado: String!){
                    getViajes(estado:$estado){
                        viajes{
                            num_pasajeros_marcado: numPasajerosMarcado,
                            estado,
                            codigo,
                            token,
                            fecha_inicio: fechaInicio,
                            bus{
                                placa,
                                cantidad_pasajeros: cantidadPasajeros
                            },
                            trayecto{
                                origen{
                                    codigo,
                                    nombre
                                },
                                destino{
                                    codigo,
                                    nombre,
                                }
                            },
                            chofer{
                                first_name: firstName,
                                last_name: lastName
                            }
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            estado: "CUR",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getViajes.status === "success") {
              if (response.data.data.getViajes.viajes) {
                this.items = response.data.data.getViajes.viajes;
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.text-red {
  color: red;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
